import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme/theme.js';
import { ButtonAppBar } from './components/layout/AppBar.js';
import { Footer } from './components/layout/Footer.js';
import { HomePage } from './pages/HomePage.js';
import { MobileAppsPage } from './pages/MobileAppsPage.js';
import { WebsitesPage } from './pages/WebsitesPage.js';
import { LogosPage } from './pages/LogosPage.js';
import { PrintWorkPage } from './pages/PrintWorkPage.js';
import { AnimationsPage } from './pages/AnimationsPage.js';
import { ComputerArtPage } from './pages/ComputerArtPage.js';
import { IllustrationsPage } from './pages/IllustrationsPage.js';
import { AboutPage } from './pages/AboutPage.js';
import { ContactPage } from './pages/ContactPage.js';
import { NotFoundPage } from './pages/NotFoundPage.js';
import { CaseStudiesPage } from './pages/CaseStudiesPage.js';
import './App.css';

function App() {
  let date = new Date();
  let year = date.getFullYear();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div className="App">
          <header className="App-header">
            <ButtonAppBar />
          </header>
          <main>
            <Routes>
              <Route path="/home" element={<HomePage />} />
              <Route path="/apps" element={<MobileAppsPage />} />
              <Route path="/websites" element={<WebsitesPage />} />
              <Route path="/logos" element={<LogosPage />} />
              <Route path="/print" element={<PrintWorkPage />} />
              <Route path="/animation" element={<AnimationsPage />} />
              <Route path="/3d" element={<ComputerArtPage />} />
              <Route path="/illustration" element={<IllustrationsPage />} />
              <Route path="/case-studies" element={<CaseStudiesPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/" element={<Navigate to="/home" replace />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
          <Footer year={year} />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
